/** @jsx jsx */
import { jsx, Box, Flex, Text } from "theme-ui";

import Div100 from "react-div-100vh";
import Layout from "components/layouts/default";
import OnScreen from "components/on-screen";

function ShippingInformation() {
  return (
    <Flex as={Div100} variant="boxes.column">
      <Layout>
        <Box
          m="auto"
          px={["m", null, "l"]}
          sx={{ maxWidth: 400, textAlign: "center" }}
        >
          <OnScreen parent>
            <OnScreen child>
              <Box>
                <Text variant="stnd.xs" mb="s">
                  Shipping Information
                </Text>
                <Text>
                  Every token includes free worldwide shipping. In mid 2020 you
                  will be able to redeem your tokens, and enter your shipping
                  information to recieve the real, physical good. Until then
                  you’re free to trade the market.
                </Text>
              </Box>
            </OnScreen>
          </OnScreen>
        </Box>
      </Layout>
    </Flex>
  );
}

export default ShippingInformation;
